
export const margin = {
  name: 'margin'
}

export const marginTop = {
  name: 'margin-top'
}

export const marginRight = {
  name: 'margin-right'
}

export const marginBottom = {
  name: 'margin-bottom'
}

export const marginLeft = {
  name: 'margin-left'
}
